module.exports = __webpack_public_path__ + "static/media/ic_group_msg.b5267482.svg";